import React from 'react';
import { useMemo, useCallback, useEffect, useState } from 'react';
import DialogBox from '../win/DialogBox';

const ProgramGroup = ({ params, programs, parentOnOpenWindow, onOpenWindow, onMenuAction, windowA, handleExit, subPrograms, windowId }) => {

	if(!subPrograms) return null;

	// A group one level down (Program Manager -> Accessories) opens its icons in
	// the desktop manager via `parentOnOpenWindow`, so they land on the desktop
	// rather than inside the little group window. A group nested inside another
	// group (Accessories -> Control Panel) is itself already a desktop window,
	// so it has no outer manager and `parentOnOpenWindow` is absent — fall back
	// to its own manager, which is the desktop.
	const openWindow = parentOnOpenWindow || onOpenWindow;

	// Check if this is the crypto group (contains winbit32.exe or sectools.exe)
	const isCryptoGroup = subPrograms.find(p => p.progName === 'winbit32.exe' );

	return (
		<div style={{ position: 'relative', height: '100%', display: 'flex', flexDirection: 'column' }}>
			<div className="program-manager" style={{ display: 'flex', flexWrap: 'wrap', flex: 1 }}>
				{subPrograms.filter(program => program.progID !== 0 && program.menuOnly !== true).map((program, index) => (
					<div
						key={index}
						className={"program-icon icon_" + program.progName.split('.')[0]}
						style={{ width: '95px', padding: '10px', textAlign: 'center' }}
						onClick={() => openWindow?.(program, {}, true)}
						title={program.tooltip}
					>
						<div style={{ fontSize: '2em' }}>{program.icon}</div>
						<div style={{ marginTop: '5px' }}>{program.title}</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default ProgramGroup;
